import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
// import * as qs from 'querystring';
import { Helper } from '../helpers/helper';

@Injectable()
export class ClientesService  {


  clientesLista: any = [];

  constructor(private _http: HttpClient, private helper: Helper ) {  }


  /*
  * Obtiene la lista completa de todos los clientes
  */
  obtenerClientes(limit?, offset?, rutas?, nombreCedula?, fecha_desde?, fecha_hasta?, sucursal?, orders?, region?, subregion?, puedeRenovar = 'todos', fallecido = 'todos') {
    let params = new HttpParams();
    params = params.append('puede_renovar', puedeRenovar);
    params = params.append('fallecido', fallecido);
    if (limit) {
      params = params.append('limit', limit);
      params = params.append('offset', offset);
    }
    if (rutas) {
      params = params.append('rutas', rutas);
    }
    if (region) {
      params = params.append('region', region);
    }
    if (subregion) {
      params = params.append('subregion', subregion);
    }
    if (nombreCedula) {
      params = params.append('nc', nombreCedula);
    }
    if (fecha_desde) {
      params = params.append('fecha_inicia', fecha_desde);
    }
    if (fecha_hasta) {
      params = params.append('fecha_termina', fecha_hasta);
    }
    if (sucursal) {
      params = params.append('sucursal', sucursal);
    }
    if (orders) {
      params = params.append('orders', orders);
    }
    return this._http.get( `${this.helper.urlServer}/api/v1/lista-clientes`,
    { headers: this.helper.getHeader(localStorage.getItem('token')), params }).map((res: any) => res);
  }

  /**
   * Verifica si el cliente ya esta registrado
   */
  revisarSiClienteExisteRegistradoDB(cedula: string) {
    return this._http.get(`${this.helper.urlServer}/api/v1/cliente/${cedula}`,
    {headers: this.helper.getHeader(localStorage.getItem('token'))});
  }

  busquedaAvanzada(data?, tipo?) {
    let params = new HttpParams();
    if (data) {
      params = params.append('nombre', data.nombre);
      params = params.append('cedula', data.cedula);
      params = params.append('telefono', data.telefono);
      params = params.append('rutas', data.ruta);
      params = params.append('direccion', data.direccion);
    }
    if (tipo) {
      params = params.append('tipo', tipo);
    }
    return this._http.get( `${this.helper.urlServer}/api/v1/lista-clientes`,
    { headers: this.helper.getHeader(localStorage.getItem('token')), params }).map((res: any) => res);
  }

  /*
  * Obtener perfil de cliente  ** Estado de cuenta del cliente **
  */
  obtenerCliente( id: number ) {
    return this._http.get(`${this.helper.urlServer}/api/v1/perfil-cliente/${id}`,
    {headers: this.helper.getHeader(localStorage.getItem('token'))});
  }

  descuentoPrestamoCuotaInfo( ID_PRESTAMO: number, ID_CLIENTE: number ) {
    return this._http.get(`${ this.helper.urlServer }/api/v1/prestamo-cliente/${ ID_PRESTAMO }/${ ID_CLIENTE }`,
    { headers: this.helper.getHeader( localStorage.getItem('token') ) });
  }

  // Cargar datos clientes por su cedula
  obtenerClientePorID(ID) {
    return this._http.get(`${this.helper.urlServer}/api/v1/ver-cliente/${ID}`,
    {headers: this.helper.getHeader(localStorage.getItem('token'))});
  }

  registrarCliente(data: any) {
    return this._http.post(`${this.helper.urlServer}/api/v1/registrar-cliente`, data,
    {headers: this.helper.getHeader(localStorage.getItem('token'))});
  }

  registrarSolicitud(data: any, isClient = false) {
    return this._http.post(`${this.helper.urlServer}/api/v1/${ isClient ? 'registrar-solicitud-cliente' : 'registrar-solicitud'}`, data,
    {headers: this.helper.getHeader(localStorage.getItem('token'))});
  }

  detalleSolicitud(ID_SOLICITUD: number) {
    return this._http.get(`${this.helper.urlServer}/api/v1/detalle-solicitud/${ID_SOLICITUD}`,
    {headers: this.helper.getHeader(localStorage.getItem('token'))});
  }

  // Obtener prestamo cliente por su id
  obtenerPrestamoCliente(id) {
    return this._http.get(`${this.helper.urlServer}/api/v1/prestamo-cliente/${id}`,
    {headers: this.helper.getHeader(localStorage.getItem('token'))}).map((res: any) => res);
  }

  // Obtener prestamo cliente por su id
  obtenerPrestamoPorId(id) {
    return this._http.get(`${this.helper.urlServer}/api/v1/cobrar-prestamo-por-id/${id}`,
    {headers: this.helper.getHeader(localStorage.getItem('token'))}).map((res: any) => res);
  }

  editarCliente(data: any) {
    return this._http.put(`${this.helper.urlServer}/api/v1/editar-cliente`, data,
    {headers: this.helper.getHeader(localStorage.getItem('token'))});
  }

  obtenerClienteParaEditar( id: number ) {
    return this._http.get(`${this.helper.urlServer}/api/v1/datos-cliente/${id}`,
    {headers: this.helper.getHeader(localStorage.getItem('token'))});
  }

  editarReferenciaPersonal(data: any,  cliente, ID_EMPLEADO) {
    return this._http.put(`${this.helper.urlServer}/api/v1/editar-cliente-referencia`,
    {data, cliente, ID_EMPLEADO},
    {headers: this.helper.getHeader(localStorage.getItem('token'))});
  }

  agregarReferenciaPersonal(data: any, cliente, ID_EMPLEADO) {
    return this._http.post(`${this.helper.urlServer}/api/v1/agregar-cliente-referencia`,
    {data, cliente, ID_EMPLEADO},
    {headers: this.helper.getHeader(localStorage.getItem('token'))});
  }

  removerReferenciaPersonal(ID_REFERENCIA, cliente, ID_EMPLEADO) {
    return this._http.delete(`${this.helper.urlServer}/api/v1/remover-cliente-referencia`,
    {headers: this.helper.getHeader(localStorage.getItem('token')),
    params: {cliente: JSON.stringify(cliente), ID_EMPLEADO, ID_REFERENCIA}});
  }

  obtenerClientesAtrasos(ruta?, limit?, offset?, nc?, orders?) {
    let params = new HttpParams();
    
    if(ruta){
      params = params.append('rutas', ruta);
      
    }
    if (limit) {
      params = params.append('limit', limit);
      params = params.append('offset', offset);
    }
    if (nc) {
      params = params.append('nc', nc);
    }
    if (orders) {
      params = params.append('orders', orders);
    }
    return this._http.get(`${this.helper.urlServer}/api/v1/clientes-en-atrasos`,
    { headers: this.helper.getHeader(localStorage.getItem('token')), params });
  }

  reporteClientesAtrasos(ruta = '0', nc?, orders?) {
    let params = new HttpParams();
    params = params.append('ruta', ruta);
    if (orders) {
      params = params.append('orders', orders);
    }
    return this._http.get(`${this.helper.urlServer}/api/v1/reporte-clientes-en-atrasos`,
    { headers: this.helper.getHeader(localStorage.getItem('token')), params });
  }

  reporteClientesIncobrables(ruta = '0', nc?) {
    let params = new HttpParams();
    params = params.append('ruta', ruta);
    return this._http.get(`${this.helper.urlServer}/api/v1/reporte-clientes-incobrables`,
    { headers: this.helper.getHeader(localStorage.getItem('token')), params });
  }

  obtenerClientesProximosVencer(fecha_desde?, fecha_hasta?, limit?, offset?, ruta?, orders?) {
    let params = new HttpParams();
    if (fecha_desde) {
      params = params.append('fecha_inicia', fecha_desde);
    }
    if (fecha_hasta) {
      params = params.append('fecha_termina', fecha_hasta);
    }
    if (limit) {
      params = params.append('limit', limit);
      params = params.append('offset', offset);
    }
    if (ruta) {
      params = params.append('rutas', ruta);
    }
    if (orders) {
      params = params.append('orders', orders);
    }
    return this._http.get(`${this.helper.urlServer}/api/v1/prestamos-salientes`,
    { headers: this.helper.getHeader(localStorage.getItem('token')), params });
  }

  obtenerClientesIncobrables(limit?, offset?, ruta?, orders?) {
    let params = new HttpParams();
    if (orders) {
      params = params.append('orders', orders);
    }
    if (limit) {
      params = params.append('limit', limit);
      params = params.append('offset', offset);
    }
    if (ruta) {
      params = params.append('ruta', ruta);
    }
    return this._http.get(`${this.helper.urlServer}/api/v1/clientes-incobrables`,
    { headers: this.helper.getHeader(localStorage.getItem('token')), params });
  }

  registrarNotaCliente(data: any) {
    return this._http.post(`${this.helper.urlServer}/api/v1/registrar-nota-cliente`, data,
    { headers: this.helper.getHeader(localStorage.getItem('token')) });
  }

  reporteClientesProximosVencer(dias = '7', ruta?) {
    let params = new HttpParams();
    params = params.append('dias', dias);

    if (ruta) {

      params = params.append('ruta', ruta);
    }
    return this._http.get(`${this.helper.urlServer}/api/v1/reporte-clientes-proximos-a-vencer`,
    { headers: this.helper.getHeader(localStorage.getItem('token')), params });
  }

  obtenerNotasClientes(limit?, offset?, rutas?, cliente?, empleado?, fecha_desde?, fecha_hasta?, operador?, distancia?, orders?) {
    let params = new HttpParams();
    if (orders) {
      params = params.append('orders', orders);
    }
    if (limit) {
      params = params.append('limit', limit);
      params = params.append('offset', offset);
    }
    if (rutas) {
      params = params.append('rutas', rutas);
    }
    if (cliente) {
      params = params.append('cliente', cliente);
    }
    if (empleado) {
      params = params.append('empleado', empleado);
    }
    if (fecha_desde) {
      params = params.append('fecha_inicia', fecha_desde);
    }
    if (fecha_hasta) {
      params = params.append('fecha_termina', fecha_hasta);
    }
    if (operador) {
      params = params.append('operador', operador);
    }
    if (distancia) {
      params = params.append('distancia', distancia);
    }
    return this._http.get(`${this.helper.urlServer}/api/v1/lista-notas-clientes`,
    { headers: this.helper.getHeader(localStorage.getItem('token')), params });
  }

  accesoCliente(data?) {
    let params = new HttpParams();
    if (data) {
      params = params.append('nombre', data.nombre);
      params = params.append('cedula', data.cedula);
      params = params.append('telefono', data.telefono);
      params = params.append('rutas', data.ruta);
      params = params.append('direccion', data.direccion);
      params = params.append('empleado', data.empleado);
    }
    return this._http.get( `${this.helper.urlServer}/api/v1/lista-clientes`,
    { headers: this.helper.getHeader(localStorage.getItem('token')), params }).map((res: any) => res);
  }

  darAccesoCliente(data) {
    return this._http.post(`${this.helper.urlServer}/api/v1/dar-acceso-cliente`, data,
    {headers: this.helper.getHeader(localStorage.getItem('token'))})
    .map((res: any) => res);
  }

  obtenerConfiguracion() {
    return this._http.get<any>(`${this.helper.urlServer}/api/v1/configuracion-prestamo/0`,
    { headers: this.helper.getHeader(localStorage.getItem('token')) });
  }
  actualizarNombrePadronElectoral(data: any) {
      return this._http.put(`${this.helper.urlServer}/api/v1/actualizar-nombre-cliente-padron`, data,
      {headers: this.helper.getHeader(localStorage.getItem('token'))});
  }

  omitirCambioNombrePadron(data: any) {
    return this._http.put(`${this.helper.urlServer}/api/v1/omitir-cambio-nombre-padron`, data,
    {headers: this.helper.getHeader(localStorage.getItem('token'))});
  }

  obtenerControlCobros(fecha_desde?, fecha_hasta?, limit?, offset?, ruta?) {
    let params = new HttpParams();
    if (fecha_desde) {
      params = params.append('fecha_inicia', fecha_desde);
    }
    if (fecha_hasta) {
      params = params.append('fecha_termina', fecha_hasta);
    }
    if (limit) {

      params = params.append('limit', limit);
      params = params.append('offset', offset);
    }
    if (ruta) {

      params = params.append('ruta', ruta);
    }
    return this._http.get(`${this.helper.urlServer}/api/v1/control-cobros`,
    { headers: this.helper.getHeader(localStorage.getItem('token')), params });
  }

  clienteExiste(cedula) {
    return this._http.get(`${this.helper.urlServer}/api/v1/cliente-existe/${cedula}`,
    { headers: this.helper.getHeader(localStorage.getItem('token'))});
  }

  eliminarCliente(ID_CLIENTE, razon) {
    return this._http.post(`${this.helper.urlServer}/api/v1/eliminar-cliente`,
    { ID_CLIENTE, razon }, { headers: this.helper.getHeader(localStorage.getItem('token'))});
  }

  notasCliente(ID_CLIENTE) {
    return this._http.get(`${this.helper.urlServer}/api/v1/notas-cliente/${ID_CLIENTE}`,
    { headers: this.helper.getHeader(localStorage.getItem('token'))});
  }

  fallecio(data) {
    return this._http.put(
      `${this.helper.urlServer}/api/v1/fallecio`, data,
      { headers: this.helper.getHeader(localStorage.getItem('token'))});
  }

  puede_renovar(data) {
    return this._http.put(`${this.helper.urlServer}/api/v1/puede_renovar`, data,
      { headers: this.helper.getHeader(localStorage.getItem('token'))});
  }

  importarClienteRuta(data) {
    let params = new HttpParams();
    if (data) {
      params = params.append('nombre', data.nombre);
      params = params.append('cedula', data.cedula);
      params = params.append('ruta', data.ruta);
    }
    return this._http.get( `${this.helper.urlServer}/api/v1/clientes-ruta-importar`,
    { headers: this.helper.getHeader(localStorage.getItem('token')), params }).map((res: any) => res);
  }

  moverClientesRuta(data) {
    return this._http.put(
      `${this.helper.urlServer}/api/v1/mover-clientes-ruta`, data,
      { headers: this.helper.getHeader(localStorage.getItem('token'))});
  }

  editarSolicitud(data: any) {
    return this._http.put(`${this.helper.urlServer}/api/v1/editar-solicitud`, data,
    {headers: this.helper.getHeader(localStorage.getItem('token'))});
  }

  historialTelefonos(ID_CLIENTE: number) {
    return this._http.get<any[]>( `${this.helper.urlServer}/api/v1/historial-telefonos/${ID_CLIENTE}`,
    { headers: this.helper.getHeader(localStorage.getItem('token')) });
  }

  verifyRecaptcha(response: string) {
    interface RecaptchaResponse {
      success: boolean,
      challenge_ts: any,
      hostname: string,
      "error-codes": string[]
    };
    return this._http.post<RecaptchaResponse>(`${this.helper.urlServer}/api/v1/verificar-recaptcha`, { response },
    { headers: this.helper.getHeader(localStorage.getItem('token')) });
  }
}



// WEBPACK FOOTER //
// C:/Users/AINSA WEB/Documents/proyects/ROUTEMEE/routemee-web-application/src/app/services/Clientes.service.ts